/**
 * 개인정보 수집 안내 + 최종 동의 체크박스 + 제출 버튼.
 *
 * 체크박스와 버튼이 form 요소 밖에 있지만 `form` 속성으로 신청서 폼에 묶인다 —
 * 시안의 섹션 구분을 그대로 두면서 하나의 폼으로 제출된다.
 */
export function PrivacyNotice({
  formId,
  agreePrivacy,
  onAgreePrivacyChange,
  submitDisabled,
  onAgreeAll,
}) {
  return (
    <section id="privacy-notice" aria-labelledby="privacy-title" className="bg-surface-muted py-10">
      <div className="inner">
        <div className="flex flex-col gap-4">
          <img
            src="/assets/icons/unit-shield.svg"
            alt=""
            aria-hidden="true"
            width="44"
            height="44"
            className="h-11 w-11"
            loading="lazy"
          />
          <h2 id="privacy-title" className="section-title">
            개인정보 수집 및 이용에 대한 안내
          </h2>
        </div>

        <div className="info-card mt-8">
          <p className="doc-lead">
            (주)플레인비트(이하 ‘회사’)은(는) 개인정보보호법에 따라 이용자의 개인정보 보호 및
            권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과
            같은 처리방침을 두고 있습니다.
            <br />
            ‘회사’ 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여
            공지할 것입니다.
          </p>

          <div className="relative overflow-x-auto">
            <table className="privacy-table">
              <caption className="sr-only">개인정보 수집 항목·목적·보유 기간</caption>
              <thead>
                <tr>
                  <th scope="col">수집 항목</th>
                  <th scope="col">수집 목적</th>
                  <th scope="col">보유 기간</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    (필수) 이메일, 휴대전화번호, 회사전화번호, 직책, 부서,
                    <br />
                    회사명, 접속 로그, 접속 IP 정보, 법정대리인 이름
                  </td>
                  <td>
                    서비스 도입 및 상담
                    <br />
                    서비스 안내 및 지원
                  </td>
                  <td>3년 보관 후 폐기</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="flex flex-col gap-4">
            <p className="note-text">
              위 동의를 거부 할 권리가 있으며, 동의를 거부하실 경우 문의 처리 및 결과 회신이
              제한됩니다.
            </p>

            <label className="check-row" htmlFor="agreePrivacy">
              <input
                type="checkbox"
                id="agreePrivacy"
                name="agreePrivacy"
                form={formId}
                required
                className="check-box"
                checked={agreePrivacy}
                onChange={(event) => onAgreePrivacyChange(event.target.checked)}
              />
              <span>위 내용에 동의합니다.</span>
            </label>
          </div>
        </div>

        <div className="btn-row mt-14">
          {/* 활성/비활성 색상은 .btn-cta 의 :disabled 규칙이 담당한다 */}
          <button type="submit" form={formId} disabled={submitDisabled} className="btn-cta">
            문의 접수하기
          </button>
          <button type="button" className="btn-cta" onClick={onAgreeAll}>
            전체 동의 후 문의 접수하기
          </button>
        </div>
      </div>
    </section>
  );
}
